import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=66e133e8&scoped=true&lang=pug&"
import script from "./Aside.vue?vue&type=script&lang=js&"
export * from "./Aside.vue?vue&type=script&lang=js&"
import style0 from "@components/Aside/Aside.styl?vue&type=style&index=0&id=66e133e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e133e8",
  null
  
)

export default component.exports